export const designation = [
    {
        id: "DS748294",
        designation: "Technical Head",
        status: "Active"
      },
      {
        id: "DS748293",
        designation: "Accountant",
        status: "Active"
      },
      {
        id: "DS748292",
        designation: "Teacher",
        status: "Active"
      },
      {
        id: "DS748291",
        designation: "Librarian",
        status: "Active"
      },
      {
        id: "DS748290",
        designation: "Doctor",
        status: "Inactive"
      },
      {
        id: "DS748289",
        designation: "Driver",
        status: "Active"
      },
      {
        id: "DS748288",
        designation: "Warden",
        status: "Active"
      },
      {
        id: "DS748287",
        designation: "Receptionist",
        status: "Active"
      },
      {
        id: "DS748286",
        designation: "Therapist",
        status: "Inactive"
      },
      {
        id: "DS748285",
        designation: "Coach",
        status: "Active"
      }
]
